import React from 'react';
import Footer from './../Footer';
import { Link, withRouter } from 'react-router-dom';

import { Pages, Settings } from './Pages';

class Introduction extends React.Component {

	constructor(props) {
		super(props);

		this.page = Pages[1];
		this.handleTogglePopout = this.handleTogglePopout.bind(this);
	}

	handleTogglePopout = popout => {
		this.props.togglePopout(popout);
	}

	componentDidMount() {
		this.props.bgHoverState(this.page.color);
		this.props.imageObjects(document.querySelectorAll(Settings.imageSelectors));

		document.title = `${this.page.name.replace('<br />', '')} | Peapack 100 Anniversary`;
		document.body.className = "page-inner page-introduction";
	}

	render() {
		return  (
			<div className="page-wrapper">
				<div className="page">
					<div className="header-section wrapper">
						<div className="row">
							<div className="col-left col-12">
								<div className="header-content">
									<Link to="/" onClick={this.props.bgHoverState} className="back-button">Back</Link>
									<h1 dangerouslySetInnerHTML={{ __html: this.page.name }} />
									<div className="page-message pb-5 mt-4">Reflecting Upon the Past to <strong className="d-sm-block">Inspire the Future</strong></div>
								</div>
							</div>
						</div>
					</div>
					<div className="white-background entry-content">
						<div className="wrapper">
							<div className="row">
								<div className="col-md-8">
									<p className="leading">As we celebrate our centennial, Peapack-Gladstone Bank continues to pursue the original mission established by our founders in 1921: providing value-added banking services to our community in an environment of integrity and trust.</p>
									<p className="leading">At this opportune moment in our history, it is fitting to reflect upon our past with appreciation for our founders, clients, and employees—each of whom has helped chart the course that has made this 100-year milestone possible.</p>
									<h3>The Somerset Hills</h3>
								</div>
							</div>
							<div className="row">
								<div className="col-md-8">
									<p>The lush and expansive area between Morristown and Somerville, New Jersey, became host to a great variety of country homes or “cottages” in the Gilded Age, resulting in an elegant estate enclave that continued to expand well into the twentieth century. The period between the 1870s and the Great Depression saw affluent industrialists and their families settle in the area surrounding Bernardsville, Far Hills, Bedminster, and Peapack and Gladstone, which came to be known as The Somerset Hills.</p>
									<p>The Delaware, Lackawanna & Western (D, L & W) Railroad connected city dwellers to Gladstone in 1890 and included a “Millionaire’s Express” train, making eight runs daily between Gladstone and Hoboken. It made The Somerset Hills an ideal location for those with city business ties and cultural interests, but who wanted to establish a “country” retreat.</p>
								</div>
								<aside className="col-md-4">
									<div className="h-md-0">
										<div className="line-quote mt-md-n1">&ldquo;From the start, what became Peapack-Gladstone Bank had ties to this entire community: both the wealthy estate owners and local tradespeople and farmers.&rdquo;</div>
									</div>
								</aside>
							</div>
							<div className="row">
								<div className="col-md-8">
									<p>It was easy to succumb to the allure of The Somerset Hills, originally known as the Upper Raritan Valley of New Jersey. The area is tucked away in a peaceful and picturesque corner of the Garden State. Many socially connected and wealthy citizens had discovered the distinct pleasures of summering just forty miles west of New York City; before the close of the century, many chose to become part of the permanent colony that was developing in these gentle and luxurious hills.</p>
									<p>The wealthy newcomers, who often maintained a townhouse in New York City, or a cottage in Newport or Bar Harbor, engaged the nation’s most acclaimed architects to build their distinctive mansions. Guy Lowell, Carrère and Hastings, and George B. Post were among the architects of choice. Mr. Post, who is best known for designing the New York Stock Exchange, was the architect for numerous area residences, including his own Bernardsville Mountain home <em>Claremont</em>. In later years, Mr. Post’s grandson, William Turnbull, whose family owned a 700-acre property at the base of the Bernardsville Mountain, served as a Peapack-Gladstone Bank Director for more than twenty-five years. </p>
									<p>The well-heeled individuals who settled The Somerset Hills became immersed in the commercial and social life of their new community and contributed to its prosperity. They also provided a tremendous amount of new employment to “locals” and immigrants alike. Farmers who sold off parcels of land to the newcomers were frequently retained to help run the property. Scores of butlers, footmen, cooks, housemaids, seamstresses, stone masons, chauffeurs, and gardeners added diversity and vitality to the community, supporting local businesses as they pursued the American Dream. Also contributing to the vibrant economy were estate managers, who procured supplies needed to run a large property, including large-scale purchases of groceries, animal feed, coal, timber, oil, garden seeds, tools, and farm equipment. </p>
									<p>From the start, what became Peapack-Gladstone Bank had ties to this entire community: both the wealthy estate owners and local tradespeople and farmers. Through their connections to all these cultures, Bank founders Ellis Tiger and Garner F. Hill realized their vision for a community bank. </p>
								</div>
							</div>
						</div>
					</div>
					<Footer togglePopout={this.handleTogglePopout} />
				</div>
			</div>
		)
	}
}

export default withRouter(Introduction);